import { render, staticRenderFns } from "./newreceipt.vue?vue&type=template&id=5c90e8c7"
import script from "./newreceipt.vue?vue&type=script&lang=js"
export * from "./newreceipt.vue?vue&type=script&lang=js"
import style0 from "./newreceipt.vue?vue&type=style&index=0&id=5c90e8c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports